import { render, staticRenderFns } from "./index.vue?vue&type=template&id=583eef24&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=583eef24&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583eef24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('583eef24')) {
      api.createRecord('583eef24', component.options)
    } else {
      api.reload('583eef24', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=583eef24&scoped=true", function () {
      api.rerender('583eef24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/journal/index.vue"
export default component.exports